import { useState, useCallback, useEffect } from "react";
import useEventListener from "@use-it/event-listener";

const visibilityChangeEvent = "visibilitychange";
const focusEvent = "focus";
const blurEvent = "blur";

/**
 * useVisibility
 * @returns {{visible: boolean}}
 * @param onShow
 * @param onHide
 * @example see bottom of file
 */
export const useVisibility = (onShow = () => {}, onHide = () => {} ) => {
	const element = global.document;

	const [visible, setVisible] = useState(element.visibilityState === "visible");

	// useEffect(() => {
	// 	console.log("Visible: ", visible);
	// }, [visible]);

	const handleVisibilityChange = useCallback(() => {
		// console.log("handleVisibilityChange");
		const isHidden = element.visibilityState === "hidden";
		if (isHidden) {
			setVisible(false);
			onHide();
		}
		else {
			setVisible(true);
			onShow();
		}
	}, [onShow, onHide]);

	const handleFocus = useCallback(() => {
		// console.log("handleFocus");
		// console.trace();
		setVisible(true);
		onShow();
	}, [onShow]);

	const handleBlur = useCallback(() => {
		// console.log("handleBlur");
		// console.trace();
		setVisible(false);
		onHide();
	}, [onHide]);

	useEventListener(visibilityChangeEvent, handleVisibilityChange, element);
	useEventListener(focusEvent, handleFocus, window);
	useEventListener(blurEvent, handleBlur, window);

	return { visible };
};

/* Usage
const show = () => {
  console.log("show");
};
const hide = () => {
  console.log("hide");
};
const { visible } = useVisibility(show, hide);

useEffect(() => {
  console.log("visible: ", visible);
}, [visible]);
*/
